import Actions from "../actions";
import { produce } from "immer";

const initialState = {
    serviceProviderDashboardIndex: [],
    serviceProviderDashboardOrderMetrics:{},
    serviceProviderDashboardSalesMetrics:{}
};

const serviceProviderDashboard = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_SERVICE_PROVIDER_DASHBOARD_INDEX_LIST: {
        const serviceProviderDashboardIndexArr = Object.entries(payload?.serviceProviderDashboardIndex).reduce((accumulator, [key, value])=>{
            const tempKey = key[0].toUpperCase() + key.substring(1);
            accumulator.push({key:tempKey, value})
            return accumulator
        },[])
      draft.serviceProviderDashboardIndex = serviceProviderDashboardIndexArr;
      break;
    }

    case Actions.GET_SERVICE_PROVIDER_DASHBOARD_ORDER_METRICS_LIST: {
        draft.serviceProviderDashboardOrderMetrics = payload?.serviceProviderDashboardOrderMetrics;
      break;
    }

    case Actions.GET_SERVICE_PROVIDER_DASHBOARD_ORDER_METRICS_LIST: {
        draft.serviceProviderDashboardSalesMetrics = payload?.serviceProviderDashboardSalesMetrics;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default serviceProviderDashboard;
